export const SET_EVENTS = "setEvents";
export const SET_ATTENDEES_FOR_EVENT = "setAttendeesForEvent";
export const SET_ATTENDEE_STATUS_FOR_CURRENT_USER = "setAttendeeStateForEvent";
export const SET_CURRENT_EVENT = "setCurrentEvent";
